<template>
    <div class="main">
        <div class="header" v-if="isPc">
            <div class="logo"><img :src="logoUrl" alt="" width="200"></div>
            <div class="nav">
                <el-menu
                    :default-active="activeIndex2"
                    class="el-menu-demo"
                    mode="horizontal"
                    @select="handleSelect"
                    text-color="#333"
                    active-text-color="#ff7f00">
                    <el-menu-item index="1" @click="goAssignBlock('home',130)">首页</el-menu-item>
                    <el-menu-item index="2" @click="goAssignBlock('profile',130)">公司简介</el-menu-item>
                    <el-submenu index="3">
                        <template slot="title">产品与服务</template>
                        <el-menu-item index="3-1" @click="goAssignBlock('next_1',130)">共享专用电单车</el-menu-item>
                        <el-menu-item index="3-2" @click="goAssignBlock('next_2',130)">智能锂电池</el-menu-item>
                        <el-menu-item index="3-3" @click="goAssignBlock('next_3',130)">智能锂电运维车</el-menu-item>
                        <el-menu-item index="3-4" @click="goAssignBlock('next_4',130)">智慧运营平台</el-menu-item>
                        <el-menu-item index="3-5" @click="goAssignBlock('next_5',130)">精细化运营模式</el-menu-item>
                        <el-menu-item index="3-6" @click="goAssignBlock('next_6',130)">实时监控</el-menu-item>
                    </el-submenu>
                    <el-submenu index="4">
                        <template slot="title">招商加盟</template>
                        <el-menu-item index="4-1" @click="goAssignBlock('next_7',130)">市场现状</el-menu-item>
                        <el-menu-item index="4-2" @click="goAssignBlock('next_8',130)">合作模式</el-menu-item>
                        <el-menu-item index="4-3" @click="goAssignBlock('next_9',130)">合作流程</el-menu-item>
                        <el-menu-item index="4-4" @click="goAssignBlock('next_10',130)">服务理念</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="5"><a href="http://zhongzhongtech.com" target="_blank">众众商城</a></el-menu-item>
                </el-menu>
            </div>
            <div class="tel">
                <img :src="telUrl" alt="" width="20">
                <span>400 969 1787</span>
            </div>
        </div>
        <div class="mobile" v-else>
            <div class="logo"><img :src="logoUrl" style="width:10rem"></div>
            <div class="tel">
                <img :src="telUrl" style="width:1.3rem">
                <span @click="telNum">400 969 1787</span>
            </div>
        </div>
        <div class="tabnav" v-if="!isPc">
            <van-tabs v-model="active" @click="changeTab">
                <van-tab v-for="(item,index) in tabList" :title="item" :key="index"></van-tab>
            </van-tabs>
        </div>
        <div style="height:70px;" v-if="isPc"></div>
        <div style="height:7.8rem;" v-else></div>
        <div ref="home">
            <el-carousel trigger="click" height="880px" v-if="isPc">
                <el-carousel-item>
                    <el-image style="width:100%" :src="url1" fit="scale-down"></el-image>
                </el-carousel-item>
                <el-carousel-item>
                    <el-image style="width:100%" :src="url2" fit="scale-down"></el-image>
                </el-carousel-item>
                <el-carousel-item>
                    <el-image style="width:100%" :src="url3" fit="scale-down"></el-image>
                </el-carousel-item>
                <el-carousel-item>
                    <el-image style="width:100%" :src="url4" fit="scale-down"></el-image>
                </el-carousel-item>
                <el-carousel-item>
                    <el-image style="width:100%" :src="url5" fit="scale-down"></el-image>
                </el-carousel-item>
                <el-carousel-item>
                    <el-image style="width:100%" :src="url6" fit="scale-down"></el-image>
                </el-carousel-item>
                <el-carousel-item>
                    <el-image style="width:100%" :src="url7" fit="scale-down"></el-image>
                </el-carousel-item>
            </el-carousel>
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" v-else>
                <van-swipe-item><van-image width="100%"  fit="scale-down" :src="url1"/></van-swipe-item>
                <van-swipe-item><van-image width="100%"  fit="scale-down" :src="url2"/></van-swipe-item>
                <van-swipe-item><van-image width="100%"  fit="scale-down" :src="url3"/></van-swipe-item>
                <van-swipe-item><van-image width="100%"  fit="scale-down" :src="url4"/></van-swipe-item>
                <van-swipe-item><van-image width="100%"  fit="scale-down" :src="url5"/></van-swipe-item>
                <van-swipe-item><van-image width="100%"  fit="scale-down" :src="url6"/></van-swipe-item>
                <van-swipe-item><van-image width="100%"  fit="scale-down" :src="url7"/></van-swipe-item>
            </van-swipe>
        </div>
        <div ref="profile">
            <div><el-image style="width:100%" :src="profileUrl1" fit="scale-down"></el-image></div>
            <div><el-image style="width:100%" :src="profileUrl2" fit="scale-down"></el-image></div>
            <div><el-image style="width:100%" :src="profileUrl3" fit="scale-down"></el-image></div>
            <div><el-image style="width:100%" :src="profileUrl4" fit="scale-down"></el-image></div>
        </div>
        <div ref="next_1"><el-image style="width:100%" :src="next_1Url" fit="scale-down"></el-image></div>
        <div ref="next_2"><el-image style="width:100%" :src="next_2Url" fit="scale-down"></el-image></div>
        <div ref="next_3"><el-image style="width:100%" :src="next_3Url" fit="scale-down"></el-image></div>
        <div ref="next_4"><el-image style="width:100%" :src="next_4Url" fit="scale-down"></el-image></div>
        <div ref="next_5">
            <div><el-image style="width:100%" :src="next_5Url1" fit="scale-down"></el-image></div>
            <div><el-image style="width:100%" :src="next_5Url2" fit="scale-down"></el-image></div>
            <div><el-image style="width:100%" :src="next_5Url3" fit="scale-down"></el-image></div>
        </div>
        <div ref="next_6">
            <div><el-image style="width:100%" :src="next_6Url1" fit="scale-down"></el-image></div>
            <div><el-image style="width:100%" :src="next_6Url2" fit="scale-down"></el-image></div>
        </div>
        <div ref="next_7">
            <div><el-image style="width:100%" :src="next_7Url1" fit="scale-down"></el-image></div>
            <div><el-image style="width:100%" :src="next_7Url2" fit="scale-down"></el-image></div>
        </div>
        <div ref="next_8"><el-image style="width:100%" :src="next_8Url" fit="scale-down"></el-image></div>
        <div ref="next_9"><el-image style="width:100%" :src="next_9Url" fit="scale-down"></el-image></div>
        <div ref="next_10"><el-image style="width:100%" :src="next_10Url" fit="scale-down"></el-image></div>
        <div class="footer" v-if="isPc">
            <div class="top">
                <div class="left">
                    <el-image style="width:200px" :src="footerUrl" fit="scale-down"></el-image>
                </div>
                <div class="center"></div>
                <div class="right">
                    <div>北京市海淀区彩和坊路8号天创科技大厦808</div>
                    <div>mofangkefu@zhongzhongtech.com</div>
                    <div>400-969-1787（产品咨询、售后服务、 原材料供应商务洽谈）</div>
                </div>
            </div>
            <div class="bottom">
                <div>Copyright ©2021北京众众出行科技有限公司 
                    <a href="http://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" style="color:#333">京ICP备19043174号-1</a>    
                </div>
            </div>
        </div>
        <div class="mobile-footer" v-else>
            <div class="top">
                <div class="left">
                    <van-image width="5rem"  fit="scale-down" :src="footerUrl"/>
                </div>
                <div class="center"></div>
                <div class="right">
                    <div>北京市海淀区彩和坊路8号天创科技大厦417</div>
                    <div>mofangkefu@zhongzhongtech.com</div>
                    <div>400-969-1787（产品咨询、售后服务、 原材料供应商务洽谈）</div>
                </div>
            </div>
            <div class="bottom">
                <div>Copyright ©2021北京众众出行科技有限公司  </div>
                <div style="margin-top:0.5rem">
                    <a href="http://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" style="color:#333">京ICP备19043174号-1</a>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
export default {
    data() {
        return {
            logoUrl: require('@/assets/logo.png'),
            telUrl: require('@/assets/tel.png'),
            url1: require('@/assets/1.jpg'),
            url2: require('@/assets/2.jpg'),
            url3: require('@/assets/3.jpg'),
            url4: require('@/assets/4.jpg'),
            url5: require('@/assets/5.jpg'),
            url6: require('@/assets/6.jpg'),
            url7: require('@/assets/7.jpg'),
            profileUrl1: require('@/assets/公司简介1.png'),
            profileUrl2: require('@/assets/公司简介2.png'),
            profileUrl3: require('@/assets/公司简介3.png'),
            profileUrl4: require('@/assets/公司简介4.png'),
            next_1Url: require('@/assets/共享专用电单车.jpg'),
            next_2Url: require('@/assets/智能锂电池.jpg'),
            next_3Url: require('@/assets/共享专用运维车.jpg'),
            next_4Url: require('@/assets/智慧运营平台.jpg'),
            next_5Url1: require('@/assets/精细化1.jpg'),
            next_5Url2: require('@/assets/精细化2.jpg'),
            next_5Url3: require('@/assets/精细化3.jpg'),
            next_6Url1: require('@/assets/实时监控1.jpg'),
            next_6Url2: require('@/assets/实时监控2.jpg'),
            next_7Url1: require('@/assets/市场现状1.jpg'),
            next_7Url2: require('@/assets/市场现状2.jpg'),
            next_8Url: require('@/assets/合作模式.jpg'),
            next_9Url: require('@/assets/合作流程.jpg'),
            next_10Url: require('@/assets/服务理念.jpg'),
            footerUrl: require('@/assets/底部Logo.png'),
            activeIndex2: '1',
            isPc: true,
            active:1,
            tabList:['首页','公司简介','共享专用电单车','智能锂电池','共享专用运维车','智慧运营平台','精细化运营模式','实施运营监控','共享电单车市场','合作模式','合作流程','服务理念','众众商城']
        }
    }, 
    created(){
        console.log(this.IsPC())
        this.isPc = this.IsPC()
    },
    mounted(){},
    methods:{
        IsPC() {
            var userAgentInfo = navigator.userAgent;
            var Agents = ["Android", "iPhone",
                        "SymbianOS", "Windows Phone",
                        "iPad", "iPod"];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        telNum(){
            window.location.href = 'tel:400-969-1787';
        },
        changeTab(index, item){
            console.log(index)
            console.log(item)
            if(index == 0)this.goAssignBlock('home',50)
            if(index == 1)this.goAssignBlock('profile',50)
            if(index > 1 && index != 12)this.goAssignBlock('next_'+(index-1),50)
            if(item=='众众商城') window.location.href="http://zhongzhongtech.com";
        },
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },
        goAssignBlock(el, speed) {
            console.log(el)
            let windowH = window.innerHeight; //浏览器窗口高度
            let h = this.$refs[el].offsetHeight; //模块内容高度
            let t = this.$refs[el].offsetTop; //模块相对于内容顶部的距离
            let top = t - (windowH - h) / 2; //需要滚动到的位置，若改为 t 则滚动到模块顶部位置，此处是滚动到模块相对于窗口垂直居中的位置
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop; //滚动条距离顶部高度
            let currentTop = scrollTop; //默认滚动位置为当前滚动条位置，若改为0，则每次都会从顶部滚动到指定位置
            let requestId;
            //采用requestAnimationFrame，平滑动画
            function step() {
                //判断让滚动条向上滚还是向下滚
                if (scrollTop < top) {
                if (currentTop <= top) {
                    //   window.scrollTo(x,y) y为上下滚动位置
                    window.scrollTo(0, currentTop);
                    requestId = window.requestAnimationFrame(step);
                } else {
                    window.cancelAnimationFrame(requestId);
                }
                //向下滚动
                currentTop += speed;
                } else {
                if (top <= currentTop) {
                    //注：此处 - speed 是解决居中时存在的问题，可自行设置或去掉
                    window.scrollTo(0, currentTop - speed);
                    requestId = window.requestAnimationFrame(step);
                } else {
                    window.cancelAnimationFrame(requestId);
                }
                //向上滚动
                currentTop -= speed;
                }
            }
            window.requestAnimationFrame(step);
        }
    }
}
</script>
<style scoped lang="scss">
.main{
    width:100%;
}
.header{
    position: fixed;
    top:0;
    z-index:99;
    background: #fff;
    width: 100%;
    height:70px;
    box-sizing: border-box;
    padding:10px 20px 0;
    display: flex;
    justify-content: space-between;
    .logo{
        img{
            position: relative;
            top:-3px;
        }
    }
    .nav{
        /deep/ .el-menu.el-menu--horizontal{
            border:none;
        }
    }
    .tel{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size:18px;
        img{
            position: relative;
            top:-3px;
        }
        span{
            position: relative;
            top:-3px;
            margin-left:5px;
            font-weight: 600;
        }
    }
}
.footer{
    background: #FF7F07;
    .top{
        padding:30px 0;
        border-bottom:1px solid #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
        .left{
            flex:1;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .center{
            width:1px;
            height:100px;
            background: #ccc;
        }
        .right{
            flex:4;
            display: flex;
            justify-content: center;
            flex-direction: column;
            text-align: left;
            padding-left:80px;
            color:#eee;
            font-size:14px;
            div{
                margin:5px 0;
            }
        }
    }
    .bottom{
        padding:30px 0;
        color: #eee;
        span{
            color:#333;
        }
    }
}
.mobile{
    width:100%;
    box-sizing: border-box;
    position: fixed;
    top:0;
    height:4rem;
    box-shadow: 0 0 1rem #333;
    z-index:99;
    background: #fff;
    padding: 0 1rem 0 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    .tel{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size:1.2rem;
        span{
            margin-left:0.3rem;
        }
    }
}
.mobile-footer{
    background:#FF7F07;
    .top{
        padding:1rem;
        box-sizing: border-box;
        border-bottom:1px solid #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
        .left{
            flex:1;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .center{
            width:1px;
            height:4rem;
        }
        .right{
            flex:4;
            display: flex;
            justify-content: center;
            flex-direction: column;
            text-align: left;
            padding-left:1rem;
            color:#eee;
            font-size:1rem;
            div{
                margin:5px 0;
            }
        }
    }
    .bottom{
        padding:1rem 0;
        color: #eee;
        span{
            color:#333;
        }
    }
}
.tabnav{
    position: fixed;
    top:4rem;
    z-index:99;
    width:100%;
}
a {
    text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
    text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
    text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
    text-decoration: none;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
    text-decoration: none;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue